var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon6",
    transform: "translate(-990 -678)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4858",
    "data-name": "\\uC0AC\\uAC01\\uD615 4858",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(990 678)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "screwdriver",
    transform: "translate(999.502 687.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33686",
    "data-name": "\\uD328\\uC2A4 33686",
    d: "M8.55,2.708a4.128,4.128,0,0,0-4.236-1h0L6.93,4.333a.912.912,0,0,1,0,1.293l-1.3,1.3a.919.919,0,0,1-1.3,0L1.717,4.309a4.131,4.131,0,1,0,6.833-1.6Z",
    transform: "translate(-0.001 0)",
    fill: "#919cab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56381",
    "data-name": "\\uADF8\\uB8F9 56381",
    transform: "translate(7.145 7.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33687",
    "data-name": "\\uD328\\uC2A4 33687",
    d: "M13.8,16.131,30.015,32.345h0a3.195,3.195,0,0,1,2.322-2.322v0L16.128,13.8A4.136,4.136,0,0,1,13.8,16.131Z",
    transform: "translate(-13.801 -13.804)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33688",
    "data-name": "\\uD328\\uC2A4 33688",
    d: "M50.748,51.208a.459.459,0,0,0,.325-.784l-.326-.325a.459.459,0,0,0-.649.65l.326.325A.456.456,0,0,0,50.748,51.208Z",
    transform: "translate(-33.365 -33.368)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33689",
    "data-name": "\\uD328\\uC2A4 33689",
    d: "M57.113,57.573a.459.459,0,0,0,.325-.783l-.324-.324a.459.459,0,0,0-.65.649l.324.323A.458.458,0,0,0,57.113,57.573Z",
    transform: "translate(-36.811 -36.812)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33690",
    "data-name": "\\uD328\\uC2A4 33690",
    d: "M54.6,49.8a.46.46,0,0,0,.842-.111l.118-.445a.459.459,0,0,0-.888-.237l-.118.445a.463.463,0,0,0,.046.348Z",
    transform: "translate(-35.838 -32.666)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33691",
    "data-name": "\\uD328\\uC2A4 33691",
    d: "M52.267,58.5a.459.459,0,0,0,.841-.11l.119-.442a.46.46,0,1,0-.888-.238l-.118.442a.456.456,0,0,0,.046.349Z",
    transform: "translate(-34.578 -37.372)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33692",
    "data-name": "\\uD328\\uC2A4 33692",
    d: "M57.423,52.553a.459.459,0,0,0,.516.673l.446-.12a.459.459,0,1,0-.239-.887l-.445.12A.46.46,0,0,0,57.423,52.553Z",
    transform: "translate(-37.368 -34.579)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33693",
    "data-name": "\\uD328\\uC2A4 33693",
    d: "M48.732,54.883a.459.459,0,0,0,.516.673l.442-.117a.46.46,0,1,0-.238-.888l-.442.118a.456.456,0,0,0-.279.214Z",
    transform: "translate(-32.666 -35.84)",
    fill: "#ccd1d9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33694",
    "data-name": "\\uD328\\uC2A4 33694",
    d: "M47.576,52.766a3.672,3.672,0,1,0,1.7-6.152,3.657,3.657,0,0,0-2.656,2.656A3.661,3.661,0,0,0,47.576,52.766Zm1.3-1.3a1.779,1.779,0,0,1-.473-.82h-.006a1.837,1.837,0,0,1,3.077-1.772,1.835,1.835,0,0,1-1.778,3.067A1.792,1.792,0,0,1,48.874,51.467Z",
    transform: "translate(-24.347 -24.347)",
    fill: "#919cab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33695",
    "data-name": "\\uD328\\uC2A4 33695",
    d: "M29.594,31.846a.921.921,0,0,1-1.3,0l-1.3-1.3-1.3-1.3L24.4,27.953a.917.917,0,1,1,1.294-1.3l3.892,3.887.005.006A.918.918,0,0,1,29.594,31.846Z",
    transform: "translate(-12.247 -13.465)",
    fill: "#f17674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33696",
    "data-name": "\\uD328\\uC2A4 33696",
    d: "M42.317,2.31a2.753,2.753,0,0,1,0,3.892l0,0L31.432,17.078,27.54,13.191,38.421,2.31A2.75,2.75,0,0,1,42.317,2.31Z",
    transform: "translate(-14.089 -0.002)",
    fill: "#f15d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33697",
    "data-name": "\\uD328\\uC2A4 33697",
    d: "M18.16,33.92,9.1,42.979,7.8,41.685l9.06-9.063Z",
    transform: "translate(-3.41 -16.839)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33698",
    "data-name": "\\uD328\\uC2A4 33698",
    d: "M34.873,17.517a.458.458,0,0,1,0-.649l8.1-8.1a.459.459,0,1,1,.649.649l-8.1,8.1A.458.458,0,0,1,34.873,17.517Z",
    transform: "translate(-17.984 -3.861)",
    fill: "#f9fafb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33699",
    "data-name": "\\uD328\\uC2A4 33699",
    d: "M4.782,55.364a.427.427,0,0,0,.049-.079c0-.01.012-.016.017-.026l.975-1.891-1.3-1.3-1.891.975c-.01,0-.016.012-.026.016a.489.489,0,0,0-.079.05.5.5,0,0,0-.066.053.718.718,0,0,0-.093.151c0,.01-.011.017-.014.027L1.517,55.48a.491.491,0,0,0-.019.13s0,.008,0,.011a.451.451,0,0,0,.028.142c.005.014.01.026.016.039a.478.478,0,0,0,.089.133h0l.324.323h0a.473.473,0,0,0,.134.089l.038.016a.451.451,0,0,0,.144.028h.01a.475.475,0,0,0,.13-.019l2.137-.838c.01,0,.017-.011.027-.015a.41.41,0,0,0,.083-.044.417.417,0,0,0,.069-.049.44.44,0,0,0,.054-.066Z",
    transform: "translate(0 -27.36)",
    fill: "#919cab"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon6);
export default __webpack_public_path__ + "static/media/sec1Icon6.a7daec73c72a1e6a7e07f3b30a5c4642.svg";
export { ForwardRef as ReactComponent };